import React from 'react';
import { compose, withState, withHandlers } from 'recompose';
import {
  Row,
  Container,
  Col,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  CardSubtitle,
} from 'reactstrap';
import {
  GridContainer,
  Pagination,
  TableDataFetch,
  AddNewButton,
  withTable,
  TableSearch,
  BulkDeleteButton,
  EditDeleteButtons,
  ViewingRecords,
} from 'components/common/Tables';
import Select from 'react-select';
import classNames from 'classnames';
import { Page, withResolver } from 'components/common';
import { get } from 'lodash';
import { NotificationManager } from 'react-notifications';

// Card images don't work correctly with IE11: https://github.com/twbs/bootstrap/issues/22448
const isIE = document.documentMode || /Edge/.test(navigator.userAgent);

export const InstallerList = ({
  selected,
  match,
  url = 'installers',
  setSelected,
  countries,
  filters,
  setFilters,
  ordering,
  setOrdering,
  data,
  setData,
  limit,
  offset,
  setOffset,
  search,
  setSearch,
  isDeleteModalOpen,
  toggleDeleteModal,
  onDeleteItem,
  onDeleted,
  refreshToken,
  readOnly,
}) => (
  <Page title="Installers">
    <TableSearch onChange={setSearch} value={search} />
    <div className="clearfix">
      <BulkDeleteButton
        className="float-right mb-2"
        toggleModal={toggleDeleteModal}
        selected={selected}
        url={url}
        onDeleted={onDeleted}
        isModalOpen={isDeleteModalOpen}
        readOnly={readOnly}
      />
      <AddNewButton
        resource="Installer"
        match={match}
        className="float-left mb-2"
        readOnly={readOnly}
      />
    </div>
    <GridContainer
      items={data.results}
      selected={selected}
      onSelectedChanged={setSelected}
    >
      <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Row style={{ minWidth: '300px' }}>
          <Col xs="0" sm="2" md="3" lg="4">
            <p />
          </Col>
          <Col xs="12" sm="8" md="6" lg="4">
            <Select
              onChange={newOption => {
                if (newOption) {
                  get(filters, 'country', '') !== newOption.iso_alpha2 &&
                    setFilters({ country: newOption.iso_alpha2 });
                } else {
                  get(filters, 'country', '') !== newOption &&
                    setFilters({ country: newOption });
                }
              }}
              value={get(filters, 'country', '')}
              options={countries}
              labelKey="name"
              valueKey="iso_alpha2"
              isLoading={!countries}
              clearable
            />
            <br />
          </Col>
        </Row>
        <Row>
          {data.results.map(i => (
            <Col xs="6" sm="6" md="4" lg="4" xl="3" className="mb-2" key={i.id}>
              <Card
                className={classNames(
                  'p-2 h-100',
                  isIE ? 'd-block' : 'd-flex',
                )}
              >
                <div select="true" />
                <CardImg
                  src={i.logo_image || '/logo.png'}
                />
                <CardBody className="d-flex px-0 py-1 flex-column justify-content-end">
                  <CardTitle>
                    {i.name} 
                  </CardTitle>
                  <div className="text-right">
                    <EditDeleteButtons
                      url={match.url}
                      id={i.id}
                      onDelete={onDeleteItem}
                      readOnly={readOnly}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </GridContainer>
    <TableDataFetch
      ordering={ordering}
      refreshToken={refreshToken}
      search={search}
      limit={limit}
      url={url}
      offset={offset}
      onDataFetched={setData}
      filters={filters}
    />
    <div className="clearfix">
      <ViewingRecords
        offset={offset}
        limit={limit}
        count={data.count}
        className="float-left pt-2"
      />
      <div className="float-right pt-2">
        <Pagination
          size="sm"
          count={data.count}
          limit={limit}
          offset={offset}
          onOffsetChanged={setOffset}
        />
      </div>
    </div>
  </Page>
);

const enhance = compose(
  withTable({ limit: 100 }),
  withState('countries', 'setCountries', []),
  withState('filters', 'setFilters', null),
  withResolver(
    {
      countries: () => client => client.get('countries'),
    },
    {
      onResolved: ({ setCountries }) => ({ countries }) => {
        setCountries(countries);
      },
    }
  ),
  withHandlers({
    onDeleted: ({ onDeleted, selected }) => props => {
      onDeleted(props);
      if (props === null) {
        // === null => success
        const resource =
          selected && Object.keys(selected).length > 1
            ? 'Installers'
            : 'Installer';
        NotificationManager.success(`${resource} deleted successfully.`);
      }
    },
  })
);

export default enhance(InstallerList);



// WEBPACK FOOTER //
// ./src/pages/Installers/List.jsx